(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lo-categories"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.lo-section--categories').forEach(section => {
    const row = section.querySelector('[data-lo-category-slider]');
    const prev = section.querySelector('.lo-category-controls__button--prev');
    const next = section.querySelector('.lo-category-controls__button--next');
    if (!row || !prev || !next) return;

    const update = () => {
      const max = row.scrollWidth - row.clientWidth - 2;
      const hasOverflow = row.scrollWidth > row.clientWidth + 2;
      prev.hidden = !hasOverflow;
      next.hidden = !hasOverflow;
      prev.disabled = !hasOverflow || row.scrollLeft <= 2;
      next.disabled = !hasOverflow || row.scrollLeft >= max;
    };

    const move = direction => row.scrollBy({ left: direction * Math.max(row.clientWidth * .8, 280), behavior: 'smooth' });
    prev.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    row.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lo-hero-v3"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lo-hero-v3')) {
    customElements.define('lo-hero-v3', class extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('.lo-hero-v3__slide')];
        this.currentLabel = this.querySelector('[data-current]');
        this.panel = this.querySelector('[data-panel]');
        this.kicker = this.querySelector('[data-copy-kicker]');
        this.heading = this.querySelector('[data-copy-heading]');
        this.text = this.querySelector('[data-copy-text]');
        this.actions = this.querySelector('[data-actions]');
        this.button1 = this.querySelector('[data-copy-button-1]');
        this.button1Label = this.querySelector('[data-button-1-label]');
        this.button2 = this.querySelector('[data-copy-button-2]');
        this.button2Label = this.querySelector('[data-button-2-label]');
        this.index = 0;
        this.interval = Number(this.dataset.interval);
        this.reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.pointerId = null;
        this.addEventListener('mouseenter', this.stop);
        this.addEventListener('mouseleave', this.start);
        this.addEventListener('focusin', this.stop);
        this.addEventListener('focusout', this.handleFocusOut);
        this.addEventListener('pointerdown', this.handlePointerDown);
        this.addEventListener('pointermove', this.handlePointerMove);
        this.addEventListener('pointerup', this.handlePointerUp);
        this.addEventListener('pointercancel', this.handlePointerCancel);
        this.addEventListener('dragstart', this.preventNativeDrag);
        requestAnimationFrame(() => this.panel.classList.add('is-revealing'));
        this.start();
      }

      disconnectedCallback() {
        this.stop();
        this.removeEventListener('mouseenter', this.stop);
        this.removeEventListener('mouseleave', this.start);
        this.removeEventListener('focusin', this.stop);
        this.removeEventListener('focusout', this.handleFocusOut);
        this.removeEventListener('pointerdown', this.handlePointerDown);
        this.removeEventListener('pointermove', this.handlePointerMove);
        this.removeEventListener('pointerup', this.handlePointerUp);
        this.removeEventListener('pointercancel', this.handlePointerCancel);
        this.removeEventListener('dragstart', this.preventNativeDrag);
      }

      start = () => {
        this.stop();
        if (this.reduceMotion || this.slides.length < 2) return;
        this.timer = window.setTimeout(this.next, this.interval);
      };

      stop = () => {
        window.clearTimeout(this.timer);
      };

      next = () => {
        this.show((this.index + 1) % this.slides.length);
        this.start();
      };

      show = (newIndex) => {
        const currentSlide = this.slides[this.index];
        this.index = newIndex;
        const nextSlide = this.slides[this.index];
        currentSlide.classList.remove('is-active');
        currentSlide.setAttribute('aria-hidden', 'true');
        nextSlide.classList.add('is-active');
        nextSlide.removeAttribute('aria-hidden');
        this.updateCopy(nextSlide);
        if (this.currentLabel) this.currentLabel.textContent = String(this.index + 1).padStart(2, '0');
      };

      updateCopy = (slide) => {
        const { kicker, heading, text, buttonOne, linkOne, buttonTwo, linkTwo } = slide.dataset;
        this.kicker.textContent = kicker;
        this.kicker.hidden = !kicker;
        this.heading.textContent = heading;
        this.text.textContent = text;
        this.text.hidden = !text;
        this.button1Label.textContent = buttonOne;
        this.button1.href = linkOne || '#';
        this.button1.hidden = !buttonOne;
        this.button2Label.textContent = buttonTwo;
        this.button2.href = linkTwo || '#';
        this.button2.hidden = !buttonTwo;
        this.actions.hidden = !buttonOne && !buttonTwo;
        this.setAttribute('aria-label', heading);
        this.panel.classList.remove('is-revealing');
        void this.panel.offsetWidth;
        this.panel.classList.add('is-revealing');
      };

      handlePointerDown = (event) => {
        if (!event.isPrimary || this.slides.length < 2) return;
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        if (event.target.closest('a, button, input, select, textarea, [contenteditable="true"]')) return;

        this.pointerId = event.pointerId;
        this.pointerType = event.pointerType;
        this.pointerStartX = event.clientX;
        this.pointerStartY = event.clientY;
        this.isHorizontalDrag = false;
        this.stop();
      };

      handlePointerMove = (event) => {
        if (event.pointerId !== this.pointerId) return;

        const distanceX = event.clientX - this.pointerStartX;
        const distanceY = event.clientY - this.pointerStartY;
        if (!this.isHorizontalDrag && Math.abs(distanceX) > 10 && Math.abs(distanceX) > Math.abs(distanceY)) {
          this.isHorizontalDrag = true;
          this.setPointerCapture(event.pointerId);
          this.classList.add('is-dragging');
        }
        if (this.isHorizontalDrag) event.preventDefault();
      };

      handlePointerUp = (event) => {
        if (event.pointerId !== this.pointerId) return;

        const distanceX = event.clientX - this.pointerStartX;
        const distanceY = event.clientY - this.pointerStartY;
        const threshold = Math.min(120, Math.max(48, this.clientWidth * 0.08));
        const shouldChange = Math.abs(distanceX) >= threshold && Math.abs(distanceX) > Math.abs(distanceY);
        const pointerType = this.pointerType;
        this.clearPointer(event.pointerId);

        if (shouldChange) {
          const direction = distanceX < 0 ? 1 : -1;
          const newIndex = (this.index + direction + this.slides.length) % this.slides.length;
          this.show(newIndex);
        }
        if (pointerType !== 'mouse') this.start();
      };

      handlePointerCancel = (event) => {
        if (event.pointerId !== this.pointerId) return;
        const pointerType = this.pointerType;
        this.clearPointer(event.pointerId);
        if (pointerType !== 'mouse') this.start();
      };

      clearPointer = (pointerId) => {
        if (this.hasPointerCapture(pointerId)) this.releasePointerCapture(pointerId);
        this.pointerId = null;
        this.pointerType = null;
        this.isHorizontalDrag = false;
        this.classList.remove('is-dragging');
      };

      preventNativeDrag = (event) => event.preventDefault();

      handleFocusOut = (event) => {
        if (!this.contains(event.relatedTarget)) this.start();
      };
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sopapets-guides-library"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sopapets-guide-library')) {
    class SopapetsGuideLibrary extends HTMLElement {
      #controller = new AbortController();

      connectedCallback() {
        const buttons = this.querySelectorAll('[data-guide-filter]');
        for (const button of buttons) {
          button.addEventListener('click', this.#filter.bind(this), { signal: this.#controller.signal });
        }
      }

      disconnectedCallback() {
        this.#controller.abort();
      }

      #filter(event) {
        const selected = event.currentTarget.dataset.guideFilter;
        const buttons = this.querySelectorAll('[data-guide-filter]');
        const cards = this.querySelectorAll('[data-guide-topic]');
        let visibleCount = 0;

        for (const button of buttons) {
          button.setAttribute('aria-pressed', String(button === event.currentTarget));
        }

        for (const card of cards) {
          const visible = selected === 'all' || card.dataset.guideTopic === selected;
          card.hidden = !visible;
          if (visible) visibleCount += 1;
        }

        const status = this.querySelector('[data-guide-status]');
        if (!status) return;
        status.textContent = '';
        requestAnimationFrame(() => {
          status.textContent = `${visibleCount} ${this.dataset.resultsSuffix}`;
        });
      }
    }

    customElements.define('sopapets-guide-library', SopapetsGuideLibrary);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sopapets-header-v3-1"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sopapets-header-v31')) {
    class SopapetsHeaderV31 extends HTMLElement {
      connectedCallback() {
        this.triggers = [...this.querySelectorAll('[data-sp31-trigger]')];
        this.panels = [...this.querySelectorAll('[data-sp31-panel]')];
        this.directLinks = [...this.querySelectorAll('[data-sp31-direct]')];
        this.desktopZone = this.querySelector('[data-sp31-desktop-zone]');
        this.drawer = this.querySelector('[data-sp31-drawer]');
        this.drawerOpen = this.querySelector('[data-sp31-drawer-open]');
        this.drawerClose = this.querySelector('[data-sp31-drawer-close]');
        this.activeMenu = null;
        this.closeTimer = null;

        for (const trigger of this.triggers) {
          trigger.addEventListener('pointerenter', () => this.openMenu(trigger.dataset.sp31Trigger));
          trigger.addEventListener('focus', () => this.openMenu(trigger.dataset.sp31Trigger));
          trigger.addEventListener('click', () => this.openMenu(trigger.dataset.sp31Trigger));
        }

        for (const panel of this.panels) {
          panel.addEventListener('pointerenter', () => window.clearTimeout(this.closeTimer));
          panel.addEventListener('pointerleave', () => this.scheduleClose());
        }

        for (const link of this.directLinks) {
          link.addEventListener('pointerenter', () => this.closeMenus());
          link.addEventListener('focus', () => this.closeMenus());
        }

        this.desktopZone?.addEventListener('pointerleave', () => this.scheduleClose());
        this.drawerOpen?.addEventListener('click', () => this.openDrawer());
        this.drawerClose?.addEventListener('click', () => this.drawer?.close());
        this.drawer?.addEventListener('close', () => this.syncDrawer(false));
        document.addEventListener('click', this.handleDocumentClick);
        document.addEventListener('keydown', this.handleKeydown);
        window.addEventListener('scroll', this.syncHeader, { passive: true });
        this.syncHeader();
      }

      disconnectedCallback() {
        window.clearTimeout(this.closeTimer);
        document.removeEventListener('click', this.handleDocumentClick);
        document.removeEventListener('keydown', this.handleKeydown);
        window.removeEventListener('scroll', this.syncHeader);
      }

      handleDocumentClick = (event) => {
        if (!this.contains(event.target)) this.closeMenus();
      };

      handleKeydown = (event) => {
        if (event.key === 'Escape') this.closeMenus();
      };

      syncHeader = () => {
        if (this.dataset.alwaysVisible === 'true') {
          this.classList.remove('is-transparent', 'is-fixed');
          return;
        }
        const isTop = window.scrollY <= 16;
        const transparentAtTop = this.dataset.headerMode === 'transparent-on-top';
        this.classList.toggle('is-transparent', transparentAtTop && isTop);
        this.classList.toggle('is-fixed', this.dataset.sticky === 'true' && !isTop);
      };

      openMenu(menuId) {
        window.clearTimeout(this.closeTimer);
        this.activeMenu = menuId;
        this.classList.add('is-open');

        for (const trigger of this.triggers) {
          trigger.setAttribute('aria-expanded', String(trigger.dataset.sp31Trigger === menuId));
        }

        for (const panel of this.panels) {
          const isActive = panel.dataset.sp31Panel === menuId;
          if (isActive) {
            panel.hidden = false;
            panel.setAttribute('aria-hidden', 'false');
            requestAnimationFrame(() => panel.classList.add('is-open'));
          } else {
            this.hidePanel(panel);
          }
        }
      }

      scheduleClose() {
        window.clearTimeout(this.closeTimer);
        this.closeTimer = window.setTimeout(() => this.closeMenus(), 180);
      }

      closeMenus() {
        window.clearTimeout(this.closeTimer);
        this.activeMenu = null;
        this.classList.remove('is-open');
        for (const trigger of this.triggers) trigger.setAttribute('aria-expanded', 'false');
        for (const panel of this.panels) this.hidePanel(panel);
      }

      hidePanel(panel) {
        panel.classList.remove('is-open');
        panel.setAttribute('aria-hidden', 'true');
        window.setTimeout(() => {
          if (!panel.classList.contains('is-open')) panel.hidden = true;
        }, 340);
      }

      openDrawer() {
        if (!this.drawer || this.drawer.open) return;
        this.drawer.showModal();
        this.syncDrawer(true);
        this.drawerClose?.focus();
      }

      syncDrawer(isOpen) {
        this.drawerOpen?.setAttribute('aria-expanded', String(isOpen));
        if (!isOpen) this.drawerOpen?.focus();
      }
    }

    customElements.define('sopapets-header-v31', SopapetsHeaderV31);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sopapets-horizontal-reviews"] && !Shopify.designMode) return;
  try {
    
  class SopapetsHorizontalReviews extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.previous = this.querySelector('[data-previous]');
      this.next = this.querySelector('[data-next]');
      this.status = this.querySelector('[data-status]');
      this.slides = [...this.querySelectorAll('[data-slide]')];
      if (!this.track || this.slides.length === 0) return;

      this.toggleAttribute('data-single', this.slides.length === 1);
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.previous?.addEventListener('click', () => this.#move(-1), { signal });
      this.next?.addEventListener('click', () => this.#move(1), { signal });
      this.track.addEventListener('scroll', () => this.#queueUpdate(), { passive: true, signal });
      window.addEventListener('resize', () => this.#queueUpdate(), { passive: true, signal });
      requestAnimationFrame(() => this.#update());
    }

    disconnectedCallback() {
      this.controller?.abort();
      if (this.frame) cancelAnimationFrame(this.frame);
    }

    #move(direction) {
      const firstSlide = this.slides[0];
      if (!firstSlide) return;
      const gap = Number.parseFloat(getComputedStyle(this.track).gap) || 0;
      const distance = firstSlide.getBoundingClientRect().width + gap;
      this.track.scrollBy({ left: direction * distance, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }

    #queueUpdate() {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = null;
        this.#update();
      });
    }

    #update() {
      const firstSlide = this.slides[0];
      if (!firstSlide) return;
      const gap = Number.parseFloat(getComputedStyle(this.track).gap) || 0;
      const distance = firstSlide.getBoundingClientRect().width + gap;
      const activeIndex = Math.min(this.slides.length - 1, Math.max(0, Math.round(this.track.scrollLeft / distance)));
      if (this.previous) this.previous.disabled = this.track.scrollLeft <= 1;
      if (this.next) this.next.disabled = this.track.scrollLeft >= this.track.scrollWidth - this.track.clientWidth - 1;
      this.toggleAttribute('data-more', this.track.scrollLeft < this.track.scrollWidth - this.track.clientWidth - 2);
      if (this.status) this.status.textContent = `${activeIndex + 1} / ${this.slides.length}`;
    }
  }

  if (!customElements.get('sopapets-horizontal-reviews')) {
    customElements.define('sopapets-horizontal-reviews', SopapetsHorizontalReviews);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sopapets-real-reviews"] && !Shopify.designMode) return;
  try {
    
  class SopapetsReviews extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      if (!this.track) return;

      this.querySelectorAll('[data-clone]').forEach((clone) => clone.remove());
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.progressItems = [...this.querySelectorAll('[data-progress-item]')];
      this.previousButton = this.querySelector('[data-previous]');
      this.nextButton = this.querySelector('[data-next]');
      this.liveRegion = this.querySelector('[data-live]');
      this.avatarCarousels = [...this.querySelectorAll('[data-avatar-carousel]')];
      this.controller = new AbortController();
      const { signal } = this.controller;

      this.#setupLoop();

      this.previousButton?.addEventListener('click', () => this.#move(-1), { signal });
      this.nextButton?.addEventListener('click', () => this.#move(1), { signal });
      this.track.addEventListener('click', (event) => {
        const button = event.target.closest('[data-review-toggle]');
        if (!button) return;
        const wrapper = button.closest('[data-review-copy]');
        const expanded = wrapper.classList.toggle('is-expanded');
        button.setAttribute('aria-expanded', String(expanded));
        button.textContent = expanded ? this.dataset.collapseLabel : this.dataset.expandLabel;
      }, { signal });
      this.track.addEventListener('scroll', () => {
        this.#queueUpdate();
        this.#scheduleLoopReset();
      }, { passive: true, signal });
      window.addEventListener('resize', () => {
        const index = this.#currentIndex();
        this.#setupLoop();
        this.#goTo(index, false);
        this.#queueUpdate();
      }, { passive: true, signal });
      document.addEventListener('shopify:block:select', (event) => this.#selectBlock(event), { signal });
      for (const carousel of this.avatarCarousels) this.#setupAvatarCarousel(carousel, signal);

      requestAnimationFrame(() => {
        this.#goTo(0, false);
        this.#update();
      });
    }

    disconnectedCallback() {
      this.controller?.abort();
      if (this.frame) cancelAnimationFrame(this.frame);
      if (this.loopResetTimer) clearTimeout(this.loopResetTimer);
    }

    #setupLoop() {
      this.querySelectorAll('[data-clone]').forEach((clone) => clone.remove());
      for (const [index, slide] of this.slides.entries()) slide.dataset.slideIndex = index;
      if (this.slides.length < 2) {
        this.renderedSlides = this.slides;
        return;
      }

      const cardWidth = this.slides[0].getBoundingClientRect().width;
      const cloneCount = Math.min(this.slides.length, Math.ceil(this.track.clientWidth / cardWidth) + 1);
      const appendClone = (slide, position) => {
        const clone = slide.cloneNode(true);
        clone.dataset.clone = position;
        clone.removeAttribute('data-block-id');
        clone.removeAttribute('data-shopify-editor-block');
        clone.setAttribute('aria-hidden', 'true');
        clone.inert = true;
        clone.querySelectorAll('[id]').forEach((element) => element.removeAttribute('id'));
        return clone;
      };

      for (const slide of this.slides.slice(-cloneCount).reverse()) {
        this.track.prepend(appendClone(slide, 'before'));
      }
      for (const slide of this.slides.slice(0, cloneCount)) {
        this.track.append(appendClone(slide, 'after'));
      }
      this.renderedSlides = [...this.track.querySelectorAll('[data-slide]')];
    }

    #queueUpdate() {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = null;
        this.#update();
      });
    }

    #currentIndex() {
      const slide = this.#nearestRenderedSlide();
      return slide ? Number(slide.dataset.slideIndex) : 0;
    }

    #nearestRenderedSlide() {
      const padding = Number.parseFloat(getComputedStyle(this.track).paddingInlineStart) || 0;
      let closestSlide = null;
      let closestDistance = Number.POSITIVE_INFINITY;
      for (const slide of this.renderedSlides) {
        const distance = Math.abs(slide.offsetLeft - padding - this.track.scrollLeft);
        if (distance < closestDistance) {
          closestSlide = slide;
          closestDistance = distance;
        }
      }
      return closestSlide;
    }

    #move(direction) {
      if (this.slides.length < 2) return;
      const currentIndex = this.#currentIndex();
      const targetIndex = (currentIndex + direction + this.slides.length) % this.slides.length;
      let targetSlide = this.slides[targetIndex];
      if (direction > 0 && currentIndex === this.slides.length - 1) {
        targetSlide = this.track.querySelector('[data-clone="after"][data-slide-index="0"]');
      } else if (direction < 0 && currentIndex === 0) {
        targetSlide = this.track.querySelector(`[data-clone="before"][data-slide-index="${this.slides.length - 1}"]`);
      }
      this.#scrollToSlide(targetSlide, true);
      this.#announce(targetIndex);
    }

    #goTo(index, animate) {
      this.#scrollToSlide(this.slides[index], animate);
    }

    #scrollToSlide(slide, animate) {
      if (!slide) return;
      const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      const padding = Number.parseFloat(getComputedStyle(this.track).paddingInlineStart) || 0;
      this.track.scrollTo({ left: slide.offsetLeft - padding, behavior: animate ? behavior : 'auto' });
    }

    #scheduleLoopReset() {
      if (this.loopResetTimer) clearTimeout(this.loopResetTimer);
      this.loopResetTimer = setTimeout(() => {
        const slide = this.#nearestRenderedSlide();
        if (slide?.dataset.clone) this.#goTo(Number(slide.dataset.slideIndex), false);
      }, 100);
    }

    #selectBlock(event) {
      const slide = this.querySelector(`[data-block-id="${CSS.escape(event.detail.blockId)}"]`);
      if (!slide) return;
      this.#scrollToSlide(slide, true);
    }

    #setupAvatarCarousel(carousel, signal) {
      const track = carousel.querySelector('[data-avatar-track]');
      const previous = carousel.querySelector('[data-avatar-previous]');
      const next = carousel.querySelector('[data-avatar-next]');
      if (!track || !previous || !next) return;

      const update = () => {
        previous.disabled = track.scrollLeft <= 1;
        next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 1;
      };
      const move = (direction) => {
        const avatar = track.querySelector('.sp-review-card__avatar');
        if (!avatar) return;
        const gap = Number.parseFloat(getComputedStyle(track).columnGap) || 0;
        const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
        track.scrollBy({ left: direction * (avatar.getBoundingClientRect().width + gap), behavior });
      };
      previous.addEventListener('click', () => move(-1), { signal });
      next.addEventListener('click', () => move(1), { signal });
      track.addEventListener('scroll', update, { passive: true, signal });
      update();
    }

    #updateReviewCopy() {
      for (const wrapper of this.querySelectorAll('[data-review-copy]')) {
        const text = wrapper.querySelector('[data-review-text]');
        const button = wrapper.querySelector('[data-review-toggle]');
        if (!text || !button) continue;
        button.hidden = !wrapper.classList.contains('is-expanded') && text.scrollHeight <= text.clientHeight + 1;
      }
    }

    #update() {
      const currentIndex = this.#currentIndex();

      if (this.previousButton) this.previousButton.disabled = this.slides.length < 2;
      if (this.nextButton) this.nextButton.disabled = this.slides.length < 2;
      for (const [index, item] of this.progressItems.entries()) {
        item.classList.toggle('is-active', index === currentIndex);
      }
      this.#updateReviewCopy();
    }

    #announce(index) {
      if (!this.liveRegion) return;
      this.liveRegion.textContent = '';
      requestAnimationFrame(() => {
        this.liveRegion.textContent = `${this.dataset.statusLabel} ${index + 1} / ${this.slides.length}`;
      });
    }
  }

  if (!customElements.get('sopapets-reviews')) {
    customElements.define('sopapets-reviews', SopapetsReviews);
  }

  } catch(e) { console.error(e); }
})();
})();
